export const MOVE_TO = 'move:to'
export const LINE_TO = 'line:to'
export const ERASE = 'erase'
export const UNDO = 'undo'
export const SELECT_PEN = 'select:pen'
export const SELECT_COLOR = 'select:color'
export const STATE_CURRENT = 'state:current'
export const SITE_WIDTH_DIVISOR = 2
export const SITE_HEIGHT_DIVISOR = 4
